import { render } from "./ProdsHeader.vue?vue&type=template&id=6d752f2a&scoped=true"
import script from "./ProdsHeader.vue?vue&type=script&lang=js"
export * from "./ProdsHeader.vue?vue&type=script&lang=js"

import "./ProdsHeader.vue?vue&type=style&index=0&id=6d752f2a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d752f2a"]])

export default __exports__